import React, { useState } from "react";

/**
 * TeamLogo — renders a team's ESPN CDN logo with a colored abbreviation
 * fallback when the image fails to load (404 / network error).
 *
 * Props:
 *   sport: "mlb" | "wnba"
 *   abbr:  team abbreviation (e.g. "NYY", "LV") — case-insensitive
 *   size:  px (default 28)
 *   className: extra wrapper classes
 *
 * ESPN CDN pattern:
 *   MLB:  https://a.espncdn.com/i/teamlogos/mlb/500/{abbr_lower}.png
 *   WNBA: https://a.espncdn.com/i/teamlogos/wnba/500/{abbr_lower}.png
 */
export default function TeamLogo({ sport = "mlb", abbr = "", size = 28, className = "" }) {
  const [failed, setFailed] = useState(false);
  const code = (abbr || "").toLowerCase();
  const src = code
    ? `https://a.espncdn.com/i/teamlogos/${sport}/500/${code}.png`
    : null;

  if (!src || failed) {
    return (
      <div
        className={`inline-flex items-center justify-center rounded-full bg-white/5 border border-white/10 font-display text-[10px] font-bold text-zinc-300 ${className}`}
        style={{ width: size, height: size }}
        data-testid={`team-logo-fallback-${abbr}`}
      >
        {abbr || "—"}
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={`${abbr} logo`}
      width={size}
      height={size}
      onError={() => setFailed(true)}
      loading="lazy"
      className={`inline-block ${className}`}
      style={{ width: size, height: size, objectFit: "contain" }}
      data-testid={`team-logo-${abbr}`}
    />
  );
}
